module.exports = __webpack_public_path__ + "static/media/snake-min.53d3698f.gif";